import './Footer.css'

function Footer() {
    return (
        <div className="footer">
            Eyes on Environmental Enforcement Project
        </div>
    )
}

export default Footer;